import {ChangeDetectionStrategy, Component, inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {CommonModule} from '@angular/common';
import {QuillViewComponent} from 'ngx-quill';

import {GetWikiItemAction} from '../../core/store/wiki/wiki.action';
import {selectWikiItem} from '../../core/store/wiki/wiki.selector';
import {OphLoadingModule} from '../../shared/design/oph-loading/oph-loading.module';
import {OphDialogFooterComponent} from './../../shared/design/oph-dialog-footer/oph-dialog-footer.component';

export type WikiViewDataProps = {
  itemId: string;
};

@Component({
  selector: 'wiki-view-article-dialog',
  standalone: true,
  imports: [QuillViewComponent, OphLoadingModule, CommonModule, OphDialogFooterComponent],
  templateUrl: './wiki-view-article-dialog.component.html',
  styleUrl: './wiki-view-article-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiViewArticleDialogComponent implements OnInit {
  readonly data = inject<WikiViewDataProps>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<WikiViewArticleDialogComponent>);
  private store$ = inject(Store);
  public wikiItem$ = this.store$.select(selectWikiItem);
  isLoading = signal<boolean>(true);

  ngOnInit(): void {
    this.store$.dispatch(
      new GetWikiItemAction({
        itemId: this.data.itemId,
        onSuccess: () => {
          this.isLoading.set(false);
        },
        onFailure: error => {
          this.isLoading.set(true);
        },
      })
    );
  }

  footerActionLabels() {
    return {
      cancel: null,
      save: 'Close',
    };
  }

  onSave() {
    this.dialogRef.close();
  }
}
